import { useState, useCallback } from "react";
import { FormattedMessage } from "react-intl";

import Contact from "../address/contact";
import { smsInputId } from "../submit/smsConfirm";
import { CzechPreselection } from "../address/phone";
import { czechMobileRegex } from "../../../../modules/dataFunctions";

const regex = new RegExp(czechMobileRegex);

const Principal = ({
  form,
  inputId,
  formItemLayout,
  initialPrincipal,
  onContactPersonChange,
}) => {
  const handlePhoneSet = useCallback(
    (phone, preselection) => {
      form.setFieldValue(
        "contactPhone" + smsInputId,
        regex.test(phone) && preselection === CzechPreselection ? phone : ""
      );
    },
    [form]
  );

  const [currentPhone, setCurrentPhone] = useState();
  const [currentPreselection, setCurrentPreselection] = useState(
    (initialPrincipal && initialPrincipal.preselection) || CzechPreselection
  );
  const handlePreselectionSelect = useCallback(
    (preselection) => {
      setCurrentPreselection(preselection.code);
      handlePhoneSet(currentPhone, preselection.code);
    },
    [handlePhoneSet, currentPhone]
  );
  const handlePhoneBlur = useCallback(
    ({ target }) => {
      setCurrentPhone(target.value);
      handlePhoneSet(target.value, currentPreselection);
    },
    [handlePhoneSet, currentPreselection]
  );

  return (
    <Contact
      form={form}
      phoneRequired
      emailRequired
      disabledPerson
      contactRequired
      separateContact
      inputId={inputId || ""}
      onPhoneBlur={handlePhoneBlur}
      formItemLayout={formItemLayout}
      onContactPersonChange={onContactPersonChange}
      onPreselectionSelect={handlePreselectionSelect}
      initialPreselection={initialPrincipal && initialPrincipal.preselection}
      emailLabel={
        <FormattedMessage
          id="registration.contacts.principal.email"
          defaultMessage="Email"
        />
      }
      phoneLabel={
        <FormattedMessage
          id="registration.contacts.principal.phone"
          defaultMessage="Telefon"
        />
      }
    />
  );
};

export default Principal;
